import CodeMirror from 'codemirror';
import { getKeywords } from './keywords.js'

const Mode = Object.freeze({
    NOT_FOUND: 0,
    TEMPLATE: 1,
    VARIABLE: 2
});

(function(mod) {
    mod(CodeMirror);
})(function(CodeMirror) {
    var WORD = /[\w$.]+/;

    CodeMirror.registerHelper("hint", "curatedplanet", function(editor, options) {
        var list = (options && options.list) || [];

        let word = (options && options.word) || WORD;
        let cur = editor.getCursor(), curLine = editor.getLine(cur.line);
        let end = cur.ch, start = end;
        while (start && word.test(curLine.charAt(start - 1))) --start;

        let curToken = start != end && curLine.slice(start, end);
        if (!curToken) return;

        let djangoModeStart = Mode.NOT_FOUND;
        let djangoModeEnd = Mode.NOT_FOUND;
        let endDjango = cur.ch, startDjango = endDjango - 1;
        while (!djangoModeStart && (startDjango > -1)) {
            if ((curLine.charAt(startDjango)==='{')) {
                if (curLine.charAt(startDjango + 1)==='%') djangoModeStart = Mode.TEMPLATE;
                if (curLine.charAt(startDjango - 1)==='{') djangoModeStart = Mode.VARIABLE;
            }
            startDjango--;
        }
        if (djangoModeStart) {
            while (!djangoModeEnd && endDjango < curLine.length) {
                if ((curLine.charAt(endDjango)==='}')) {
                    if (curLine.charAt(endDjango - 1)==='%') djangoModeEnd = Mode.TEMPLATE;
                    if (curLine.charAt(endDjango + 1)==='}') djangoModeEnd = Mode.VARIABLE;
                }
                endDjango++;
            }
            if (djangoModeStart === djangoModeEnd) {
                let found_keywords = getKeywords(curToken, djangoModeStart === Mode.TEMPLATE);
                found_keywords.forEach(element => {
                    list.push(element);
                });
            }
        }

        return {list: list, from: CodeMirror.Pos(cur.line, start), to: CodeMirror.Pos(cur.line, end)};

    });
});
